import { render, staticRenderFns } from "./Purchase-Order.vue?vue&type=template&id=67e4df56&"
import script from "./Purchase-Order.vue?vue&type=script&lang=js&"
export * from "./Purchase-Order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports